import React from 'react'
import { Link } from 'react-router-dom'

const About = () => {
    document.title="Queen Resturant-About"
  return (
    <div>
<section className="sectionFirst main">
        <section className="contentConatiainer">
          <section className="mainText">
            <h2>
              About Us
            </h2>
            <h3>
              Discover Our <br/>Restaurant Story
            </h3>
          </section>
            <div className='p'>
              Cuisine is a team work of Cuisine Restaurant Cafe, we aim at promoting the foodstuff industry through the branches. We establish and through the new dishes, and integrate between different cultes. There are some other things that we are pretty well known for. but if you want to actually find out more, then you'll have to keep reading this paragraph. Well it looks like the paragraph is going ot end soon.
            
            
              I hope you learned something important about our business. Because it looks like we have run out of room again to tell you more properly about who we are and what we do. Maybe you'll learn if you read the other sections though!
            </div><Link to="/menu">
            <button className="btnDiscover" >
                Discover Menu
              <img src="https://i.imgur.com/mdtAg35.png" className="btnArrow"/>
            </button></Link>
        </section>
      </section>

    </div>
  )
}

export default About
